module.exports = __webpack_public_path__ + "static/media/banner_medium.67a77c2d.jpg";